import { Switch, Route, Redirect } from 'react-router-dom';
import { useUserAuth } from '../state/userAuthContext';
import { toolsRoutes } from './allRoutes';

const switchRoutes = (
  <Switch>
    {toolsRoutes.map((prop, key) => {
      if (prop.layout === 'tools') {
        return <Route path={`/${prop.layout}${prop.path}`} component={prop.component} key={key} exact />;
      }
      return null;
    })}
    <Redirect from="/tools" to="/tools/listing" />
  </Switch>
);

const Tools = () => {
  const { user } = useUserAuth();
  return <> {user && switchRoutes} </>;
};

export default Tools;
